module.exports = __webpack_public_path__ + "static/media/spend.fcb78024.png";